export enum DriverHrPanelDynamicFieldTypeEnum {
  //personal
  FirstName = 1,
  SecondName = 2,
  LastName = 3,
  IdNumber = 4,
  ParentsNames = 5,
  FamilyName = 6,
  Nationality = 7,
  Pesel = 8,
  BirthCountry = 9,
  BirthDate = 10,
  BirthPlace = 11,
  //localization
  Town = 12,
  Street = 13,
  BuildingNumber = 14,
  FlatNumber = 15,
  Voivodeship = 16,
  PostalCode = 18,
  //health insurance
  Pensioner = 19,
  Annuitant = 20,
  DisabilityCertificate = 21,
  //social insurance
  InsuranceFromWork = 22,
  InsuranceFromDuty = 23,
  InsuranceFromOtherOrder = 24,
  InsuranceFromContract = 25,
  InsuredFromDifferentSource = 26,
  //personal
  Citizenship = 27,
  //hr documents
  WorkPermit = 28,
  ContractOfMandateOtherEmployer = 29,
}
